module.exports = __webpack_public_path__ + "img/marketing_map_6.f23bc2f2.png";